/* eslint-disable no-nested-ternary */
import './index.css';
import { useMultiStepInstructionsContext } from '@datacamp/multi-step-instructions';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { LicenseAgreementManager } from '../../containers/LicenseAgreementManager';
import { ProvidedSolutionContext } from '../../containers/ProvidedSolutionContext';
import { CentralLayoutWithoutInteractivePane } from './CentralLayoutWithoutInteractivePane';
import { ConversationalInterfaceLayout } from './ConversationalInterfaceLayout';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Exercise = _ref => {
  let {
    checkExercise,
    environment,
    exercise,
    exerciseId,
    onExerciseFinished,
    onExerciseStatusUpdate,
    resources,
    showExercise,
    updateLostXp,
    user
  } = _ref;
  const {
    isSolutionDisplayed,
    xpWon
  } = useMultiStepInstructionsContext();
  const [currentId, setCurrentId] = useState(undefined);
  if (currentId !== exerciseId) {
    setCurrentId(exerciseId);
  }
  useEffect(() => {
    showExercise();
  }, [exerciseId, showExercise]);
  useEffect(() => {
    updateLostXp({
      exerciseId,
      lostXp: exercise.xp - xpWon
    });
  }, [exercise, exerciseId, xpWon, updateLostXp]);
  const onContinue = () => onExerciseFinished({
    id: exerciseId
  });
  const onCheckExercise = React.useCallback((message, success, submittedCode) => {
    checkExercise(message, success, submittedCode);
  }, [checkExercise]);
  const shouldShowCentralInterface = ['DownloadFilesExcelOpenQuestion', 'DownloadFilesExcelMultipleChoice'].includes(exercise.question.flavor);
  const interfaceToShow = shouldShowCentralInterface ? 'central' : 'conversational';
  return ___EmotionJSX("div", {
    className: "remote-desktop-exercise"
  }, ___EmotionJSX(ProvidedSolutionContext, {
    exercise: exercise,
    exerciseId: exerciseId,
    solutionShown: isSolutionDisplayed
  }, ___EmotionJSX(LicenseAgreementManager, {
    environment: environment,
    exercise: exercise
  }, interfaceToShow === 'central' ? ___EmotionJSX(CentralLayoutWithoutInteractivePane, {
    environment: environment,
    exercise: exercise,
    exerciseId: exerciseId,
    onCheckExercise: onCheckExercise,
    onContinue: onContinue,
    resources: resources
  }) : interfaceToShow === 'conversational' ? ___EmotionJSX(ConversationalInterfaceLayout, {
    environment: environment,
    exercise: exercise,
    exerciseId: exerciseId,
    onCheckExercise: onCheckExercise,
    onContinue: onContinue,
    onExerciseStatusUpdate: onExerciseStatusUpdate,
    resources: resources,
    user: user
  }) : null)));
};
export default Exercise;